import {
  ListGroup, Row, Col, Form
} from "react-bootstrap";

import IRoleHwrc from "interfaces/models/IRoleHwrc";

interface UserRoleItemProps {
  register : any;
  role: IRoleHwrc;
}

const UserRoleItem = ({
  register, role, ...props
} : UserRoleItemProps) => (
  <ListGroup.Item {...props}>
    <Row className="align-items-center">
      <Col xs={11}>
        <Form.Label
          data-testid={`roleLabel_${role.roleId}`}
          className="d-flex w-100 mb-0"
          htmlFor={`rdRole_${role.roleId}`}
        >
          {role.roleName}
        </Form.Label>

      </Col>
      <Col xs={1} className="d-flex justify-content-end">
        <Form.Check
          {...register("role")}
          id={`rdRole_${role.roleId}`}
          data-testid={`rbAllocate_${role.roleId}`}
          className="d-inline-flex custom-switch custom-switch-md ms-2"
          type="radio"
          aria-required="false"
          aria-label={`${role.roleName} role`}
          value={role.roleId}
        />
      </Col>
    </Row>
  </ListGroup.Item>
);

export default UserRoleItem;
